import React from "react";
import Permission from "components/permission";
import { useBreadCrumbs } from "components/use-hooks";
import { localizeByKey } from "components/service/localize";
import type { TPermission } from "components/permission/helpers/permission-types-helper";

const permissionBasePath = Permission.Const.basePath;

interface IPermissionOverviewSubPageProps {
    permission: TPermission | undefined;
}

const PermissionOverviewSubPage: React.FC<IPermissionOverviewSubPageProps> = ({ permission }) => {
    const breadcrumbs = [
        {
            label: localizeByKey("BREADCRUMBS.Label_Permissions"),
            path: `${permissionBasePath}`,
        },
        {
            label:
                (permission && localizeByKey(permission.slug || `${permission.group_name}.${permission.action}`)) ||
                localizeByKey("BREADCRUMBS.Label_Create"),
            path:
                (permission && `${permissionBasePath}/${permission?.id}`) ||
                `${permissionBasePath}/create`,
        },
    ];

    useBreadCrumbs(breadcrumbs);

    return (
        <div className="row-grid col-xl-2">
            <div className="col-left">
                <Permission.Forms.Edit permission={permission} />
            </div>
            <div className="col-right"></div>
        </div>
    );
};

export default PermissionOverviewSubPage;